import React from 'react';
import DocumentIcon from '@material-ui/icons/InsertDriveFile';

const Document = (props) => <DocumentIcon {...props} />;

export default Document;
